/**
 * @license Codistica
 *
 * Copyright (c) 2020, Codistica and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.md file in the root directory of this source tree.
 *
 * BUILD DATE: Fri Jul 10 2020 16:51:08 GMT+0200 (Central European Summer Time)
 */

/** @module browser/modules/element-utils/can-scroll-x */

/**
 * @description Determines if element can scroll horizontally.
 * @param {HTMLElement} elem - Element.
 * @returns {boolean} Result.
 */
function canScrollX(elem) {
  var computedStyle = window.getComputedStyle(elem);
  return !(computedStyle.overflowX === 'hidden' || computedStyle.overflowX === 'visible' || elem.clientWidth === elem.scrollWidth);
}

export { canScrollX };